import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LOG_CHATBOT } from '../../../constants/log.constant';
import { IDatosAdicionales } from '../../../models/log.model';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';
import { ChatBotV2Service } from '../../../services/chat-bot-v2/chat-bot-v2.service';
import { ChatBotLogService } from '../../../services/chat-bot/chat-bot-log.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-terminos',
  templateUrl: './chat-bot-asesor-v2-terminos.component.html',
})
export class ChatBotAsesorV2TerminosComponent {
  constructor(
    public chatBotV2DS: ChatBotV2DataService,
    public chatBotV2S: ChatBotV2Service,
    private chatBotLogService: ChatBotLogService,
    public dialogRef: MatDialogRef<ChatBotAsesorV2TerminosComponent>,
  ) {}

  onClick(acepta: boolean) {
    this.guardarLog(acepta);
    this.dialogRef.close(acepta);
  }

  private guardarLog(acepta: boolean) {
    this.chatBotV2S.guardarAceptacionTYC(acepta);
    if (!acepta) return;
    const logInicio: IDatosAdicionales = {
      accion: LOG_CHATBOT.INICIO,
      glosa: LOG_CHATBOT.GLOSA_INICIO,
      metodo: 'LOG',
      payload: { MENSAJE: 'EL USUARIO ACEPTA LAS CONDICIONES DE USO DEL CHATBOT.' },
      stash: 'log_negocio',
      tipoLog: 'NEGOCIO',
      salida: '-',
      estado: 'OK',
    }
    this.chatBotLogService.guardarLog(logInicio);
  }

}
